import { useQuery, useMutation, useQueryClient } from "react-query";
import UserService from "@/services/user.service";
import { toast } from "react-toastify";

export const ListUsers = (page: number, searchQuery: string) => {
    return useQuery({
        queryKey: ["users", page, searchQuery],
        queryFn: () => UserService.getUsers({ page, limit: 10, search: searchQuery }).then(res => res.data),
        keepPreviousData: true,
        staleTime: 1000 * 5,
        retry: false,
    });
};

export const useGetUserById = (id: string) => {
    return useQuery({
        queryKey: ["user", id],
        queryFn: () => UserService.getUserById(id).then(res => res.data),
        keepPreviousData: true,
        staleTime: 1000 * 5,
        retry: false,
    });
};

export const useUpdateUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: { id: string; data: any }) => UserService.updateUser(id, data),
        onSuccess: () => {
            toast.success("User updated successfully!");
            queryClient.invalidateQueries(["users"]);
        },
        onError: (error: any) => {
            toast.error(error?.message || "Failed to update user");
        },
    });
};

export const useDeleteUser = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => UserService.deleteUser(id),

        onSuccess: () => {
            toast.success("User deleted successfully.");
            queryClient.invalidateQueries({ queryKey: ["users"] });
        },
        onError: () => {
            toast.error("Failed to delete user. Please try again.");
        },
    });
}